import { useFetchFacilityMedia } from "features/entity/services";
import { useRoles } from "hooks";
import React, { useState } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { useParams, useSearchParams } from "react-router-dom";
import FacilityZipFileDownload from "../FacilityZipFileDownload";
import FacilityFileUpload from "../FacilityFileUpload";
import FacilityFileListItem from "../FacilityFileListItem";
import MetaPagination from "components/ui/MetaPagination";

const FacilityFilesTab = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "files";

  const { facilityId } = useParams();
  const { isCertifier } = useRoles();

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const { error, isLoading, files, meta, setFiles } = useFetchFacilityMedia({
    facilityId,
    fetchByDefault: tab === "files",
    page,
    perPage,
  });

  const onFileUploaded = (uploadedFiles) => {
    setFiles((prevFiles) => [...uploadedFiles, ...prevFiles]);
  };

  return (
    <>
      <Row className="px-3">
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className="d-flex justify-content-end align-items-center"
        >
          <FacilityZipFileDownload files={files} />
          <FacilityFileUpload onFileUploaded={onFileUploaded} />
        </Col>
      </Row>
      <Card.Body className="table-responsive">
        <Table hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Level</th>
              <th>Updated</th>
              {!isCertifier && <th>Action</th>}
            </tr>
          </thead>
          <tbody className="table-group-divider">
            <FacilityFileListItem
              error={error}
              files={files}
              setFiles={setFiles}
              isLoading={isLoading}
            />
          </tbody>
        </Table>
      </Card.Body>
      <Card.Footer>
        <MetaPagination
          meta={meta}
          setPage={setPage}
          perPage={perPage}
          setPerPage={setPerPage}
        />
      </Card.Footer>
    </>
  );
};

export default FacilityFilesTab;
